import SearchShowMore from './SearchShowMore';

export default SearchShowMore;
